import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";

export default function (state = initialState.wishlist, action) {
  switch (action.type) {
    case ActionTypes.ADD_TO_WISHLIST:
      let exist = false;
      const newState = state.map(product => {
        if (product.id === action.payload.id) {
          exist = true;
        }
        return product;
      });
      if (!exist) newState.push(action.payload);
      return newState;
    case ActionTypes.REMOVE_FROM_WISHLIST:
          return state.filter(product => product.id !== action.payload);
      case ActionTypes.EMPTY_WISHLIST: // + "_FULFILLED":
          return [];
    default:
      return state;
  }
}
